<div class="flex items-center gap-3">
  @if (message) {
    <span
      class="font-montserrat inline-block w-fit font-medium text-current"
      [ngClass]="{
        'text-sm': size === 'sm',
        'text-base': size === 'md',
        'text-lg': size === 'lg'
      }"
    >
      {{ message }}
    </span>
  }
  <span
    class="relative flex flex-shrink-0 items-center justify-center"
    [ngClass]="{
      'h-3 w-3': size === 'sm',
      'h-5 w-5': size === 'md',
      'h-7 w-7': size === 'lg'
    }"
  >
    <svg
      class="block size-full animate-spin"
      [ngClass]="{
        'text-brand-primary-pure': variant === 'primary',
        'text-neutral-hight-pure': variant === 'secondary',
        'text-neutral-low-dark': variant === 'tertiary',
        'text-current': variant === 'default'
      }"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  </span>
</div>
